import {
  insertProfileVideoService,
  deleteProfileVideoService,
  getProfileVideoService,
} from "../services/AthleteService";
import {
  setLoading,
  setBtnLoading,
  setReload,
  setProfileVideos,
  setProfileVideosInsert,
  setProfileVideoDelete,
} from "./slices/profileVideoSlice";

export const insertProfileVideoAction =
  (apiInstance, file, profileVideoId, setUploadProgress) =>
  async (dispatch) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", profileVideoId);
      const response = await insertProfileVideoService(
        apiInstance,
        formData,
        setUploadProgress,
      );
      dispatch(setProfileVideosInsert(response.data));
    } catch (err) {
      console.error(err);
    }
  };

export const insertProfileVideoWeightRoomAction =
  (apiInstance, file, profileVideoId, title, weight, reps, setIsOpen) =>
  async (dispatch) => {
    dispatch(setBtnLoading(true));
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", profileVideoId);
      formData.append("title", title);
      formData.append("weight", weight);
      formData.append("reps", reps);
      const response = await insertProfileVideoService(apiInstance, formData);
      dispatch(setProfileVideosInsert(response.data));
      setIsOpen(false);
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(setBtnLoading(false));
    }
  };

export const deleteProfileVideoAction =
  (apiInstance, profileVideoId) => async (dispatch) => {
    dispatch(setLoading(true));
    try {
      await deleteProfileVideoService(apiInstance, profileVideoId);
      dispatch(setProfileVideoDelete(profileVideoId));
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(setLoading(false));
    }
  };

export const getProfileVideosAction =
  (apiInstance, userId) => async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await getProfileVideoService(apiInstance, userId);
      dispatch(setProfileVideos(response.data));
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(setLoading(false));
      dispatch(setReload(true));
    }
  };
